import { RouterView } from "vue-router";
import { WarrantyListRouting } from "./warranty-list/warranty-list.routing";
import { WarrantyWarningRouting } from "./warranty-warning/warranty-warning.routing";
export const WarrantyRouting = {
  path: "/warranty",
  name: "warranty",
  redirect: "/warranty/warranty-warning/list",
  component: RouterView,
  meta: { title: "保修管理" },
  children: [...WarrantyWarningRouting, ...WarrantyListRouting],
};
